module.exports = __webpack_public_path__ + "img/DAY3-2.6c2a45e2.jpg";